import BuySellSwitch from './BuySellSwitch';

export default BuySellSwitch;
